<template>
	<div class="pddsku">
		<div class="form">
			<el-form :inline="true" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="110px">
				<el-form-item label="渠道退货规则" prop="return_rule" class="item">
					<el-select v-model="ruleForm.return_rule" placeholder="请选择渠道退货规则">
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_return_rule" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="撕防伪规则" prop="security_rule" class="item">
					<el-select v-model="ruleForm.security_rule" placeholder="请选择撕防伪规则">
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_security_rule" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="发货时间规则" prop="send_time_rule" class="item">
					<el-select v-model="ruleForm.send_time_rule" placeholder="请选择发货时间规则">
						<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_send_time_rule" :key="k">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="利润比例" prop="profit" class="item">
					<el-input-number v-model="ruleForm.profit" :controls="false" :max="100">
					</el-input-number>
				</el-form-item>
				
				<el-form-item label="配货率" prop="allocation_rate" class="item">
					<el-input-number v-model="ruleForm.allocation_rate" :controls="false" :max="100">
					</el-input-number>
				</el-form-item>
				
				<el-form-item label="准时率" prop="on_time_rate" class="item">
					<el-input-number v-model="ruleForm.on_time_rate" :controls="false" :max="100">
					</el-input-number>
				</el-form-item>
				
				<el-form-item label="运费" prop="delivery_price" class="item">
					<el-input-number v-model="ruleForm.delivery_price" :precision="2" :controls="false">
					</el-input-number>
				</el-form-item>
				
				<el-form-item label="显示最大数量" prop="show_max_num" class="item">
					<el-input-number v-model="ruleForm.show_max_num" :controls="false">
					</el-input-number>
				</el-form-item>
				
				<el-form-item label="是否同步" prop="is_sync" class="item">
					<el-select v-model="ruleForm.is_sync" placeholder="是否同步">
						<el-option label="不同步" :value="0"></el-option>
						<el-option label="同步" :value="1"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item>
					<el-button type="primary" @click="onsub()">保存</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="table" v-for="(v,k) in list" :key="k">
			<div class="info">
				<div class="img">
					<img :src="v.product.pic" v-if="v.product.pic">
				</div>
				<div>款号:{{v.product.style_number}}</div>
				<div>品牌:{{v.product.brand}}</div>
				<div>大类:{{v.product.cid_first}}</div>
				<div>中类:{{v.product.cid_second}}</div>
				<div>小号:{{v.product.cid_third}}</div>
				<div>系列:{{v.product.series}}</div>
				<div>性别:{{v.product.sex}}</div>
				<div>颜色:{{v.product.color}}</div>
				<div>重量:{{v.product.scale}}</div>
				<div>发布季:{{v.product.season}}</div>
				<div>价格:{{v.product.price}}</div>
			</div>
			<div class="tablediv">
				<el-table :data="v.tablelist" style="width: 100%" border height="100%" :cell-class-name="cellClassName">
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="100px" fixed="left">
					</el-table-column>
					<el-table-column :prop="onprop(x)" v-for="(x,y) in v.compare_price.sizes" :key="y" width="70px" align="center" header-align="center">
						<template slot="header" slot-scope="scope">
							<div>{{x.size}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="stock" label="合计" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="product_price" label="零售价" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="true_discount" label="折扣" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="agent_price" label="代理价" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="stop_take_time" label="截单" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="prev_send_delivery_date" label="预发" align="center" header-align="center" min-width="90px">
					</el-table-column>
					<el-table-column prop="free_return_rate" label="退货比+扣款" align="center" header-align="center" min-width="110px">
					</el-table-column>
					<el-table-column prop="allocation_rate" label="配货率" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="on_time_rate" label="准时率" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="security" label="撕防伪" align="center" header-align="center" min-width="80px">
						<template slot-scope="scope">
							<div>{{onsecurity(scope.row.security)}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="库存更新" align="center" header-align="center" min-width="100px">
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Pddsku',
		data() {
			return {
				config: {},
				list: [],
				ruleForm: {
					shop_id: "",
					goods_id: "",
					is_sync: "",
					return_rule: "",
					security_rule: "",
					send_time_rule: "",
					profit: "",
					allocation_rate: "",
					on_time_rate: "",
					delivery_price: "",
					show_max_num: "",
				},
				rules: {
					return_rule: [{
						required: true,
						message: '请选择渠道退货规则',
						trigger: 'change'
					}],
					
					security_rule: [{
						required: true,
						message: '请选择撕防伪规则',
						trigger: 'change'
					}],
					
					send_time_rule: [{
						required: true,
						message: '请选择发货时间规则',
						trigger: 'change'
					}],
					
					profit: [{
						required: true,
						message: '请输入利润比例',
						trigger: 'blur'
					}],
					
					allocation_rate: [{
						required: true,
						message: '请输入配货率',
						trigger: 'blur'
					}],
					
					on_time_rate: [{
						required: true,
						message: '请输入准时率',
						trigger: 'blur'
					}],
					
					delivery_price: [{
						required: true,
						message: '请输入运费',
						trigger: 'blur'
					}],
					
					show_max_num: [{
						required: true,
						message: '请输入显示最大数量',
						trigger: 'blur'
					}],
				}
			}
		},
		props: {
			checkobj: { //用于回显
				type: Object,
				default: {
					shop_id: "",
					goods_id: ""
				}
			},
		},
		
		inject: ['appdata'],
		
		mounted() {
			this.info();
		},
		
		methods: {
			info() {
				this.$axios.post('api/user/pdd_sku_info', this.checkobj).then(res => {
					if (res.data.code == 0) {
						this.config = res.data.data.config;
						this.list = [];
						var list = res.data.data.items;
						list.forEach((v,k)=>{
							if(v.compare_price.list.length > 0) {
								if(v.compare_price.sizes) {
									var arr = [
										{shop_name: "单买价"},
										{shop_name: "拼团价"},
										{shop_name: "最高代理价"},
									];
									v.compare_price.sizes.forEach((x,y)=>{
										if(x.pdd_price.single_price) {
											arr[0]['size_'+x.id] = x.pdd_price.single_price;
											arr[0]['size_'+x.id+'_select'] = 1;
										}
										
										if(x.pdd_price.group_price) {
											arr[1]['size_'+x.id] = x.pdd_price.group_price;
											arr[1]['size_'+x.id+'_select'] = 1;
										}
										
										if(x.pdd_price.max_agent_price) {
											arr[2]['size_'+x.id] = x.pdd_price.max_agent_price;
											arr[2]['size_'+x.id+'_select'] = 1;
										}
									})
								}
								
								v.tablelist = arr.concat(v.compare_price.list);
								this.list.push(v);
							}
							
							for (let key in this.ruleForm) {
								if(key == 'delivery_price') {
									this.ruleForm[key] = this.config['delivery_price_str']
								} else {
									this.ruleForm[key] = this.config[key];
								}
								
							}
							
						})
						
						
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onsecurity(n) {
				if (n == 1) {
					return ''
				}
			
				if (n == 2) {
					return '撕防伪'
				}
			
				if (n == 3) {
					return '不撕防伪'
				}
			},
			
			onprop(v) {
				return "size_" + v.id;
			},
			
			
			
			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(column.property.indexOf('size_')!=-1) {
					if(row[column.property+'_select'] == 1) {
						return "yellor_row"
					}
				}
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						this.$axios.post('api/user/pdd_sku_config_set', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.info();
								this.$emit('onconfig_set',"");
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
				
			}
		}
	}
</script>

<style scoped lang="less">
	.img {
		width: 150px;
		img {
			width: 100%;
		}
	}
	
	.table {
		width: 100%;
		display: flex;
		margin-bottom: 5px;
		.info {
			font-size: 14px;
			width: 160px;
			// height: 100%;
			border: 1px solid #b5b5b5;
			padding: 5px;
			box-sizing: border-box;
			border-right: none;
		}
		
		.tablediv {
			width: calc(100% - 160px);
			padding: 5px;
			box-sizing: border-box;
			border: 1px solid #b5b5b5;
		}
	}
	
	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
	
	/deep/ .item .el-select {
		width: 200px;
	}
	
	/deep/ .item .el-input-number {
		width: 200px;
	}
	
	/deep/ .item .el-textarea {
		width: 200px;
	}
</style>


// WEBPACK FOOTER //
// src/common/pddsku.vue